import type { FC } from 'react';
import { Link } from '@compat/router';
import { observer } from 'mobx-react';
import { Picture } from '@ui';
import { CPCategoriesList } from './CatalogCategory/components/components';
import MobileCatalogView from './MobileCatalogView';
import { twcls } from '@utils/twcls';
import icons from '@icons';
import { oysterBarIcon } from '@images';
import { useStores } from '@root/src/stores';
import { useCatalogMenu } from '../useCatalogMenu';

const {
  pricetag: { midYellow: pricetagMidYellowFilled },
  fire: { red: fireRedFilled },
  flash: { red: flashRedFilled }
} = icons.Fill;
const {
  percent: { black: percentBlackOutlined }
} = icons.Outline;
const list = [
  {
    id: 'newbee',
    title: 'Новинки',
    href: '/catalog/newbee',
    icon: flashRedFilled
  },
  { id: 0, title: 'Акции', href: '/promotions', icon: percentBlackOutlined },
  { id: 1, title: 'Скидки', href: '/catalog/promo', icon: fireRedFilled },
  {
    id: 2,
    title: 'Распродажа',
    href: '/catalog/rasprodazha',
    icon: pricetagMidYellowFilled
  }
];

const cardClassName = twcls(`
  w-full
  h-full
  flex
  flex-col
  pt-4
  items-center
  text-center
  px-2.5
  rounded-xl
  transition-shadow
  bg-[var(--light-grey)]
  hover:shadow-main-light
  hover:text-main-dark-red
`);

const CatalogMain: FC = observer(() => {
  const { cartStore } = useStores();
  // ЭТАП 2 — меню с SSR-фолбэком: плитки категорий приходят в SSR-HTML
  const menu = useCatalogMenu();
  const filteredMenu = menu.filter(item => {
    if (item.isBarMenu && !cartStore.isCurrentAddressValidForExpress) {
      return false;
    }
    return true;
  });

  return (
    <div>
      <div className='hidden sm:block'>
        <MobileCatalogView scrollWindow />
      </div>
      <div className='grid grid-cols-[15rem,calc(100%-15rem-24px)] gap-x-6 mt-2.5 sm:hidden'>
        <div>
          <CPCategoriesList menu={filteredMenu} />
        </div>
        <div>
          <h1 className='block mb-8 text-3xl font-medium'>Каталог товаров</h1>
          <div className='flex items-center max-w-full mb-8 space-x-3 overflow-auto md:mb-5 md:pb-3 fromLg:grid fromLg:grid-cols-6 fromLg:gap-x-5 fromLg:space-x-0'>
            {list.map(item => (
              <Link
                key={item.id}
                className='w-full flex items-center justify-center allMd:px-5 py-4 allMd:py-3 bg-[var(--light-grey)] rounded-xl transition-shadow hover:shadow-main-light hover:text-main-dark-red'
                to={item.href}
              >
                <Picture
                  pictureClassName='mr-2'
                  icon={item.icon}
                  height='24'
                  width='24'
                />
                {item.title}
              </Link>
            ))}
          </div>
          <div
            className={twcls(`
            w-full
            grid
            grid-cols-[repeat(auto-fill,minmax(_10rem,1fr))]
            auto-rows-[8.25rem]
            mb-10
            gap-5
            md:gap-3
            items-start h-full
          `)}
          >
            {!!filteredMenu.length &&
              filteredMenu.map(item => (
                <Link key={item.id} className={cardClassName} to={item.url}>
                  <Picture
                    icon={item.icon}
                    width='40'
                    height='40'
                    alt={item.title || 'Изображение'}
                    pictureClassName='mb-4'
                  />
                  {item.title}
                </Link>
              ))}
            <Link
              key='oyster-bar'
              className={cardClassName}
              style={{ backgroundColor: '#DEF4FF' }}
              to='/catering-ustrichniy-bar'
            >
              <Picture
                icon={oysterBarIcon}
                width='40'
                height='40'
                alt='Выездной устричный бар'
                pictureClassName='mb-4'
              />
              <span className='whitespace-pre-line'>
                Выездной{'\n'}устричный бар
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
});

export default CatalogMain;
